export const isNullOrWhitespace = input => {
  if (typeof input === 'undefined' || input == null) return true;
  return input.replace(/\s/g, '').length < 1;
};

export const buildURL = (input = []) => {
  return input.join('/');
};

export const formatNamed = (base, placeholders) => {
  var regex = new RegExp('{(.*?)}', 'gm');
  base = base.replace(regex, (_, match) => placeholders[match] || '');
  return base;
};

export const formatUrlTemplate = (urlTemplate, urlParams) => {
  return urlTemplate.replace(/{([a-z]*)}/gi, (_, param) => {
    return urlParams[param];
  });
};

export const getArticleForString = str => {
  const firstChar = str.charAt(0).toLowerCase();

  return ['a', 'e', 'i', 'o', 'u'].includes(firstChar) ? 'an' : 'a';
};
